import { connect } from 'react-redux';
import OAuthUserLogin from './OAuthUserLogin';
import { getTranslation } from "../../../reducers/common/localization";
import { Utils } from '../../../utils/utils';
import {
    fetchAuthorize,
    getLoginFetchingStatus,
    getLoginError,
    cleanLoginError,
    getIs2FARequired,
    getLoginAuthoriseStatus,
    logout
} from '../../../reducers/account/login';
import {
    fetchCheckOAuthRequestParams,
    getOAuthClientData,
    fetchOAuthGiveAccess,
    getOAuthRedirectTo,
    getOAuthError,
    getOAuthLoading
} from '../../../reducers/oauth/oauth'
import { getUserEmail, getUserPersonalData, isLoading, } from '../../../reducers/account/userData';

const mapStateToProps = (state, { location }) => {
    return {
        locationParams: Utils.getParamsFromLocationSearch(location.search),
        oauthError: getOAuthError(state),
        oauthLoading: getOAuthLoading(state),
        requestData: getOAuthClientData(state),
        redirectTo: getOAuthRedirectTo(state),
        isAuthorised: getLoginAuthoriseStatus(state),
        loginError: getLoginError(state),
        loginLoading: getLoginFetchingStatus(state),
        userDataLoading: isLoading(state),
        is2FARequired: getIs2FARequired(state),
        userEmail: getUserEmail(state),
        userData: getUserPersonalData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogIn: (data) => {
            dispatch(fetchAuthorize(data));
        },
        onUnmount: () => dispatch(cleanLoginError()),
        onCheckRequestParams: (params) => {
            dispatch(fetchCheckOAuthRequestParams(params));
        },
        onGiveAccess: (data) => {
            dispatch(fetchOAuthGiveAccess(data))
        },
        onLogout: () => {
            dispatch(logout());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OAuthUserLogin);



// WEBPACK FOOTER //
// ./src/components/accountManagement/oauthUserLogin/OAuthUserLogin.container.js